export { AccountBalanceWallet } from './legacy/account-balance-wallet';
export { Add } from './legacy/add';
export { AddCircle } from './legacy/add-circle';
export { AddCircleFilled } from './legacy/add-circle-filled';
export { AmericanExpress } from './legacy/american-express';
export { ArrowBack } from './legacy/arrow-back';
export { ArrowBackIosNew } from './legacy/arrow-back-ios-new';
export { ArrowDown } from './legacy/arrow-down';
export { ArrowDownward } from './legacy/arrow-downward';
export { ArrowForward } from './legacy/arrow-forward';
export { ArrowForwardIos } from './legacy/arrow-forward-ios';
export { ArrowLeft } from './legacy/arrow-left';
export { ArrowRight } from './legacy/arrow-right';
export { ArrowUp } from './legacy/arrow-up';
export { ArrowUpward } from './legacy/arrow-upward';
export { Bolt } from './legacy/bolt';
export { Boxes } from './legacy/boxes';
export { BrandShipping } from './legacy/brand-shipping';
export { CalendarToday } from './legacy/calendar_today';
export { Cancel } from './legacy/cancel';
export { Check } from './legacy/check';
export { CheckCircle } from './legacy/check-circle';
export { CheckCircleFilled } from './legacy/check-circle-filled';
export { CheckboxFilled } from './legacy/checkbox_filled';
export { CheckboxOutlineBlankFilled } from './legacy/checkbox_outline_blank_filled';
export { Close } from './legacy/close';
export { CurrencyExchange } from './legacy/currency-exchange';
export { Delete } from './legacy/delete';
export { Edit } from './legacy/edit';
export { EmojiFlags } from './legacy/emoji-flags';
export { Error } from './legacy/error';
export { ErrorFilled } from './legacy/error-filled';
export { ExpandLess } from './legacy/expand-less';
export { ExpandMore } from './legacy/expand-more';
export { FastDelivery } from './legacy/fast-delivery';
export { FilterAlt } from './legacy/filter-alt';
export { Help } from './legacy/help';
export { HelpFilled } from './legacy/help-filled';
export { IndeterminateCheckbox } from './legacy/indeterminate_checkbox';
export { IndeterminateCheckboxFilled } from './legacy/indeterminate_checkbox_filled';
export { Info } from './legacy/info';
export { InfoFilled } from './legacy/info-filled';
export { LeftFacing } from './legacy/left-facing';
export { ListAlt } from './legacy/list-alt';
export { Loading } from './legacy/loading';
export { LocalShipping } from './legacy/local-shipping';
export { LocationOn } from './legacy/location-on';
export { Lock } from './legacy/lock';
export { Logout } from './legacy/logout';
export { Mail } from './legacy/mail';
export { Map } from './legacy/map';
export { Menu } from './legacy/menu';
export { Minimize } from './legacy/minimize';
export { Mood } from './legacy/mood';
export { MoreHoriz } from './legacy/more-horiz';
export { MoreVert } from './legacy/more-vert';
export { MyLocation } from './legacy/my-location';
export { OpenInNew } from './legacy/open-in-new';
export { OpenWith } from './legacy/open-with';
export { PhotoCamera } from './legacy/photo-camera';
export { PlayCircleFilled } from './legacy/play-circle-filled';
export { Plus } from './legacy/plus';
export { PushPin } from './legacy/push-pin';
export { RadioButton } from './legacy/radio_button';
export { RadioButtonChecked } from './legacy/radio_button_checked';
export { Remove } from './legacy/remove';
export { Returns } from './legacy/returns';
export { Sell } from './legacy/sell';
export { SellFilled } from './legacy/sell-filled';
export { Settings } from './legacy/settings';
export { ShoppingBasket } from './legacy/shopping-basket';
export { Star } from './legacy/star';
export { StarFilled } from './legacy/star-filled';
export { StarHalf } from './legacy/star-half';
export { TaskAlt } from './legacy/task-alt';
export { ThreeSixty } from './legacy/three-sixty';
export { ThreeDRotation } from './legacy/three_d_rotation';
export { TipsAndUpdates } from './legacy/tips_and_updates';
export { TouchApp } from './legacy/touch-app';
export { UnionPay } from './legacy/unionpay';
export { Verified } from './legacy/verified';
export { VerifiedSecurity } from './legacy/verified-security';
export { ViewInAr } from './legacy/view-in-ar';
export { Visa } from './legacy/visa';
export { Visibility } from './legacy/visibility';
export { VisibilityOff } from './legacy/visibility-off';
export { Warning } from './legacy/warning';
export { WarningFilled } from './legacy/warning-filled';
